import { render, staticRenderFns } from "./ChannelDetailModal.vue?vue&type=template&id=5d527a48&scoped=true"
import script from "./ChannelDetailModal.vue?vue&type=script&lang=js"
export * from "./ChannelDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ChannelDetailModal.vue?vue&type=style&index=0&id=5d527a48&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d527a48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d527a48')) {
      api.createRecord('5d527a48', component.options)
    } else {
      api.reload('5d527a48', component.options)
    }
    module.hot.accept("./ChannelDetailModal.vue?vue&type=template&id=5d527a48&scoped=true", function () {
      api.rerender('5d527a48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channel/components/ChannelDetailModal.vue"
export default component.exports